import MediaStatusComponent from './mediaStatus.component';

export const mediaStatusModule = {
	name: 'mediaStatusComponent',
};

export default angular
	.module(mediaStatusModule.name, [])
	.component('mediaStatus', new MediaStatusComponent()).name;
